const sortByLabel = (a, b) => a.label.localeCompare(b.label);

export const CROP_OPTIONS = [
  { label: 'Alfalfa seed', value: 'Alfalfa seed' },
  { label: 'Barley', value: 'Barley' },
  { label: 'Beans', value: 'Beans' },
  { label: 'Buckwheat', value: 'Buckwheat' },
  { label: 'Canola', value: 'Canola' },
  { label: 'Chickpea', value: 'Chickpea' },
  { label: 'Corn', value: 'Corn' },
  { label: 'Durum', value: 'Durum' },
  { label: 'Flax', value: 'Flax' },
  { label: 'Lentils', value: 'Lentils' },
  { label: 'Oats', value: 'Oats' },
  { label: 'Peas', value: 'Peas' },
  { label: 'Quinoa', value: 'Quinoa' },
  { label: 'Rye', value: 'Rye' },
  { label: 'Soybeans', value: 'Soybeans' },
  { label: 'Wheat', value: 'Wheat' },
  { label: 'Rice', value: 'Rice' },
  { label: 'Sorghum', value: 'Sorghum' },
  { label: 'Mustard', value: 'Mustard' },
  { label: 'Canary seed', value: 'Canary seed' },
  { label: 'Hemp', value: 'Hemp' },
  { label: 'Coriander', value: 'Coriander' },
  { label: 'Sunflower', value: 'Sunflower' },
  { label: 'Black beans', value: 'Black beans' },
  { label: 'Pinto beans', value: 'Pinto beans' },
  { label: 'Mung beans', value: 'Mung beans' },
  { label: 'Faba beans', value: 'Faba beans' },
  { label: 'Navy beans', value: 'Navy beans' },
  { label: 'Great northern beans', value: 'Great northern beans' },
].sort(sortByLabel);

export const SCOUTING_OPTIONS = [
  { label: 'None', value: 'NONE', default: true },
  { label: 'Low', value: 'LOW' },
  { label: 'Medium', value: 'MEDIUM' },
  { label: 'High', value: 'HIGH' },
].sort(sortByLabel);

export const CHEMICAL_OPTIONS = [
  { label: 'Insecticide', value: 'INSECTICIDE' },
  { label: 'Herbicide', value: 'HERBICIDE' },
  { label: 'Fungicide', value: 'FUNGICIDE' },
  { label: 'Adjuvant', value: 'ADJUVANT' },
  { label: 'Other', value: 'OTHER' },
].sort(sortByLabel);



// WEBPACK FOOTER //
// ./src/common/constants/options.js